import { Component,PLATFORM_ID ,Inject } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';

@Component({
  selector: 'scorecard-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent, 
    MatProgressSpinnerModule],
  templateUrl: './scorecard-free.component.html',
  styleUrl: './scorecard-free.component.css'
})
export class ScorecardFreeComponent {
  isScreenLarge: boolean = false;

  currentAnalysisMode: string;

  public datos_pagina = {
    percentage: 79,
    metrics: 27,
    cefr_level: 'C2',
  };
  public datos_pagina_statistics = {
    averageSyllablesPerSentence: 40.64,
    syllablesPer100Word: 149.89,
    wordsWithMoreThan2SyllablesPercentage: 12.59,
  };
  public datos_pagina_readability = {
    flesch_reading: 52.31,
    flesch_kincaid: 12.75,
  };

  public percentage: number | undefined | null;
  public metrics: number | undefined | null;
  public cefr_level: string | undefined | null;

  public averageSyllablesPerSentence: number | undefined | null;
  public syllablesPer100Words: number | undefined | null;
  public wordsWithMoreThan2SyllablesPercentage: number | undefined | null;

  public flesch_reading: number | undefined | null;
  public flesch_kincaid: number | undefined | null;

  constructor( @Inject(PLATFORM_ID) private platformId: Object,private analysisService: AnalysisServiceService){}

  ngOnInit(): void {
    this.percentage = this.datos_pagina.percentage;
    this.metrics = this.datos_pagina.metrics;
    this.cefr_level = this.datos_pagina.cefr_level;

    this.averageSyllablesPerSentence = this.datos_pagina_statistics.averageSyllablesPerSentence;
    this.syllablesPer100Words = this.datos_pagina_statistics.syllablesPer100Word;
    this.wordsWithMoreThan2SyllablesPercentage = this.datos_pagina_statistics.wordsWithMoreThan2SyllablesPercentage;

    this.flesch_reading= this.datos_pagina_readability.flesch_reading;
    this.flesch_kincaid = this.datos_pagina_readability.flesch_kincaid;
    
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  isMatchingLevel(level: string): boolean {
    return level === this.datos_pagina.cefr_level;
  }

}
